import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
    Collapse,
      CircularProgress,
        Chip,
  Card,
  CardContent,
  Avatar,
  LinearProgress,
  Divider,
  Tooltip,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Add, Edit, Delete } from "@mui/icons-material";
import {
  getLowestLevelTask,
  getProjectList,
  getProjectsByUserId,
} from "../../api/project";
import { useDispatch, useSelector } from "react-redux";
import { getEmployeesList } from "../../api/employee";
import {
  getAllExpenses,
  getExpensebyID,
  insertExpensesData,
  updateExpensebyID,
} from "../../api/expensesManagement";
import { showAlert, showSuccess } from "../../actions/alert";
import { getallSitesData, getSitesMgmtbyProjectID } from "../../api/sites";
import { getAllInventory } from "../../api/inVentory";
import PersonIcon from "@mui/icons-material/Person";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import NotesIcon from "@mui/icons-material/Notes";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
const expenseTypes = ["Labor", "Material", "Equipment"];

const initialExpense = {
  expenseId: "",
  project_id: "",
  site_id: "",
  task_id: "",
  expense_type: "",
  status: "",
  expense_date: "",
  amount: 0,
  notes: "",
};

export default function ExpensesManagement() {
  const [expenses, setExpenses] = useState([]);
  const [sitesData, setSitesData] = useState([]);
  const [formData, setFormData] = useState(initialExpense);
  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [projectId, setProjectId] = useState("");
  const [projects, setProjects] = useState([]);
  const [taskList, setTaskList] = useState([]);
  const [employeesList, setEmployeesList] = useState([]);
  const [taskDisabled, setTaskDisabled] = useState(true);
  const [invetoryArray, setInventoryArray] = useState([]);
  const user = useSelector((state) => state.user);
    const [expandedRows, setExpandedRows] = useState({});
  
    const [subTableData, setSubTableData] = useState({});
    const [loadingRows, setLoadingRows] = useState({});
  const [lineItems, setLineItems] = useState([
    { task_id: "", inventory_id: "", unit_price: "", quantity: "" },
  ]);

  const handleLineItemChange = (index, field, value) => {
    const updatedItems = [...lineItems];
    updatedItems[index][field] = value;
    if (field === "inventory_id") {
      const selectedInventory = invetoryArray.find(
        (item) => item.id.toString() === value.toString()
      );
      if (selectedInventory) {
        updatedItems[index].unit_price = selectedInventory.unit_price || "";
      } else {
        updatedItems[index].unit_price = "";
      }
    }
    // Recalculate total amount
    const totalAmount = updatedItems.reduce((sum, item) => {
      const price = parseFloat(item.unit_price) || 0;
      const qty = parseFloat(item.quantity) || 0;
      return sum + price * qty;
    }, 0);

    setLineItems(updatedItems);
    setFormData((prev) => ({
      ...prev,
      amount: totalAmount.toFixed(2),
    }));
  };

  const addLineItem = () => {
    setLineItems([
      ...lineItems,
      { task_id: "", inventory_id: "", unit_price: "", quantity: "" },
    ]);
  };

  const removeLineItem = (index) => {
    const updatedItems = [...lineItems];
    updatedItems.splice(index, 1);

    const totalAmount = updatedItems.reduce((sum, item) => {
      const price = parseFloat(item.unit_price) || 0;
      const qty = parseFloat(item.quantity) || 0;
      return sum + price * qty;
    }, 0);

    setLineItems(updatedItems);
    setFormData((prev) => ({
      ...prev,
      amount: totalAmount.toFixed(2),
    }));
  };

  const handleOpen = () => {
    setFormData(initialExpense);
    setEditMode(false);
    setOpen(true);
  };

  const fetchExpensesData = async () => {
    try {
      const { data } = await getAllExpenses(user.token, {});
      if (data.status) {
        setExpenses(data.data);
      }
    } catch (error) {
      console.error("Error fetching sites:", error);
    }
  };
  const handleClose = () => {
    setFormData(initialExpense);
    setLineItems([
      { task_id: "", inventory_id: "", unit_price: "", quantity: "" },
    ]);
    setOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updated = { ...formData, [name]: value };

    // if (["hoursOrQty", "rate"].includes(name)) {
    //   const qty = name === "hoursOrQty" ? +value : +formData.hoursOrQty;
    //   const rate = name === "rate" ? +value : +formData.rate;
    //   updated.Amount = qty * rate;
    // }

    setFormData(updated);
  };

  const dispatch = useDispatch();
  const handleSave = async (event) => {
    event.preventDefault();

    if (editMode) {
      try {
        const { data } = await updateExpensebyID(
          { ...formData, exp_lines: lineItems },
          user.token,
          formData.id
        );
        if (data.status) {
          // setSites(
          //   sites.map((site) => (site.id === formData.id ? formData : site))
          // )
          dispatch(showAlert("Expense Created Successfully"));
          fetchExpensesData();
          // showSuccess("Expense Created Successfully");
        }
      } catch (error) {
        console.error("Error updating site:", error);
      } finally {
        setLineItems([
          { task_id: "", inventory_id: "", unit_price: "", quantity: "" },
        ]);
        setFormData(initialExpense);
      }
    } else {
      try {
        const { data } = await insertExpensesData(
          { ...formData, exp_lines: lineItems },
          user.token
        );
        if (data.status) {
          // setSites(
          //   sites.map((site) => (site.id === formData.id ? formData : site))
          // )
          fetchExpensesData();
          dispatch(showAlert("Expense Created Successfully"));

          showSuccess("Expense Created Successfully");
        }
      } catch (error) {
        console.error("Error updating site:", error);
      } finally {
        setLineItems([
          { task_id: "", inventory_id: "", unit_price: "", quantity: "" },
        ]);
        setFormData(initialExpense);
      }
    }

    setOpen(false);
  };
  const handleEdit = (expense) => {
    setProjectId(expense?.project_id);
    setFormData(expense);
    setEditMode(true);
    setOpen(true);
  };

  const handleDelete = (id) => {
    setExpenses((prev) => prev.filter((exp) => exp.expenseId !== id));
  };

  useEffect(() => {
    fetchExpensesData();
    projectList();
  }, []);
  const projectList = () => {
    getProjectList(user.token)
      .then((res) => {
        setProjects(res.data.data);
      })
      .catch((err) => console.error("Error fetching projects:", err));
  };
  useEffect(() => {
    if (!projectId) return;
    setTaskDisabled(true);

    const project = projects.find((p) => p.id.toString() === projectId.toString());
  
    if (!project) {
      // Project with the given project_id was not found
      // Handle the situation accordingly
      return;
    }
    FetchAllSites();
    const isPmForProject = project.project_role === "PM";

    getLowestLevelTask(projectId, user.token, !isPmForProject)
      .then((res) => {
        setTaskList(res.data.data);
        setTaskDisabled(false);
      })
      .catch((err) => console.error("Error fetching tasks:", err));
   
  }, [projectId]);
  useEffect(() => {
    if (formData.id) {
      getTaskLinesItems(formData.id);
    }
  }, [formData.id]);
  const getTaskLinesItems = async (id) => {
    try {
      const { data } = await getExpensebyID(user.token, id);
      if (data.status) {
        setLineItems([...data.lines] || []);
      }
    } catch (err) {
      console.error("Error fetching sub table:", err);
    }
  };

  console.log(lineItems, "lineItems");
  useEffect(() => {
   
    fetchAllInvetory();
  }, [user.token]);

  const FetchAllSites = async () => {
    try {
      const { data } = await getSitesMgmtbyProjectID(
        user.token,
         projectId
      );
      if (data.status) {
        setSitesData(data.data);
      }
    } catch (error) {
      console.error("Error fetching all sites:", error);
    }
  };

  const fetchAllInvetory = async () => {
    try {
      const { data } = await getAllInventory(user.token, {
        limit: "",
        offset: "",
        status: "stock_item",
        vendorname: "",
        manufacturer: "",
        category: "",
        internalSku: "",
        itemDescription: "",
        is_active: "t",
      });
      // setRefresh(false);
      // setMovethenRefresh(false);
      setInventoryArray([...data.data.Inventory]);
      return {
        rows: data.data.Inventory,
        total: parseInt(data.data.total),
        error: false,
      };
    } catch (error) {
      console.log(error?.message);
      // setMovethenRefresh(false);
      // setRefresh(false);
      return { error: true };
    }
  };
  
  const handleToggleSubTable = async (id) => {
    const isOpen = expandedRows[id];

    if (isOpen) {
      setExpandedRows((prev) => ({ ...prev, [id]: false }));
    } else {
      setLoadingRows((prev) => ({ ...prev, [id]: true }));
      try {
        const { data } = await getExpensebyID(user.token,id);
        if (data.status) {
          setSubTableData((prev) => ({ ...prev, [id]: data.lines }));
          setExpandedRows((prev) => ({ ...prev, [id]: true }));
        }
      } catch (err) {
        console.error("Error fetching sub table:", err);
      } finally {
        setLoadingRows((prev) => ({ ...prev, [id]: false }));
      }
    }
  };
  return (
    <>
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Expense Management
          </Typography>
        </Box>
        <Button
          variant="contained"
          className="blue-button"
          startIcon={<Add />}
          onClick={handleOpen}
          type="button"
        >
          Add Expense
        </Button>
      </Box>

      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Actions</TableCell>

              <TableCell>Project</TableCell>
              <TableCell>Site</TableCell>
              {/* <TableCell>Task</TableCell> */}
              {/* <TableCell>Type</TableCell> */}
              <TableCell>Date</TableCell>
              {/* <TableCell>Qty/Hrs</TableCell>
              <TableCell>Rate</TableCell> */}
              <TableCell>Amount</TableCell>
              <TableCell>Notes</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {expenses.map((exp) => (
                <React.Fragment key={exp.id}>
              <TableRow key={exp.id}>
                <TableCell>
                  <IconButton onClick={() => handleEdit(exp)}>
                    <Edit />
                  </IconButton>
                     <IconButton
                                        color="info"
                                        onClick={() => handleToggleSubTable(exp.id)}
                                      >
                                        {expandedRows[exp.id] ? (
                                          <VisibilityOffIcon fontSize="small" />
                                        ) : (
                                          <VisibilityIcon fontSize="small" />
                                        )}
                                      </IconButton>
                  {/* <IconButton onClick={() => handleDelete(exp.expenseId)}>
                    <Delete />
                  </IconButton> */}
                </TableCell>
                <TableCell>{exp?.project_name || "-"}</TableCell>
                <TableCell>{exp?.site_name || "-"}</TableCell>
                {/* <TableCell>{exp?.task_name || "-"}</TableCell> */}
                {/* <TableCell>{exp?.expense_type || "-"}</TableCell> */}
                <TableCell>{exp.expense_date}</TableCell>
                {/* <TableCell>{exp.hoursOrQty}</TableCell>
                <TableCell>{exp.rate}</TableCell> */}
                <TableCell>
                  {parseFloat(exp.amount || "0").toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
                </TableCell>
                <TableCell>{exp.notes}</TableCell>
                <TableCell>{exp.status || "-"}</TableCell>
              </TableRow>
                    <TableRow>
                                <TableCell colSpan={7} sx={{ p: 0, bgcolor: "#f8f9fa" }}>
                                  <Collapse
                                    in={expandedRows[exp.id]}
                                    timeout="auto"
                                    unmountOnExit
                                  >
                                    <Box sx={{ p: 3 }}>
                                      {loadingRows[exp.id] ? (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            py: 4,
                                          }}
                                        >
                                          <CircularProgress size={32} />
                                          <Typography sx={{ ml: 2 }}>
                                            Loading Expense details...
                                          </Typography>
                                        </Box>
                                      ) : (
                                        <Box style={{ zoom: "0.75" }}>
                                          <Typography
                                            variant="h6"
                                            sx={{ mb: 2, color: "primary.main" }}
                                          >
                                            Expense Details for {exp.project_name}
                                          </Typography>
                                          <Divider sx={{ mb: 2 }} />
              
                                        {(subTableData[exp.id] || []).length === 0 ? (
  <Box
    sx={{
      textAlign: "center",
      py: 4,
      color: "text.secondary",
    }}
  >
    <Typography variant="body1">
      No Expenses found for this project
    </Typography>
  </Box>
) : (
  <TableContainer component={Paper}>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell><strong>Task</strong></TableCell>
          <TableCell><strong>Inventory</strong></TableCell>
          <TableCell><strong>Type</strong></TableCell>
          <TableCell><strong>Unit Price ($)</strong></TableCell>
          <TableCell><strong>Quantity</strong></TableCell>
          {/* <TableCell><strong>Notes</strong></TableCell> */}
        </TableRow>
      </TableHead>
      <TableBody>
        {(subTableData[exp.id] || []).map((s, idx) => (
          <TableRow key={idx} hover>
            {/* Expense Name */}
            <TableCell>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {s.task_name}
              </Typography>
            </TableCell>

            {/* Site Type */}
            <TableCell>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {s.inventory_name}
              </Typography>
            </TableCell>

            {/* Manager */}
            <TableCell>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {s.expense_type}
              </Typography>
            </TableCell>

            {/* Duration */}
            <TableCell>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {s.unit_price}
              </Typography>
            </TableCell>

            {/* Progress */}
            <TableCell>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {s.quantity}
              </Typography>
            </TableCell>

          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
)}

                                        </Box>
                                      )}
                                    </Box>
                                  </Collapse>
                                </TableCell>
                              </TableRow>
                                 </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog  className="flex justify-center expense-modal" open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle>{editMode ? "Edit Expense" : "Add Expense"}</DialogTitle>
        <form onSubmit={handleSave} >
          <DialogContent className="!h-[470px] overflow-scroll">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel>Project</InputLabel>
                  <Select
                    name="project_id"
                    value={formData.project_id}
                    onChange={(e) => {
                      handleChange(e);
                      setProjectId(e.target.value);
                    }}
                  >
                    <MenuItem value="">
                      <em>Select Project</em>
                    </MenuItem>
                    {projects.map((p, i) => (
                      <MenuItem key={i} value={p.id}>
                        {p.project_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel>Site</InputLabel>
                  <Select
                    name="site_id"
                    value={formData.site_id}
                    onChange={handleChange}
                  >
                    <MenuItem value="">
                      <em>Select Site</em>
                    </MenuItem>
                    {sitesData.map((site) => (
                      <MenuItem key={site.site_id} value={site.site_id}>
                        {site.site_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <MenuItem value="">
                      <em>Select Status</em>
                    </MenuItem>

                    <MenuItem value={"Pending Approval"}>
                      Pending Approval
                    </MenuItem>
                    <MenuItem value={"Approved by Accounting"}>
                      Approved by Accounting
                    </MenuItem>
                    <MenuItem value={"Rejected"}>Rejected</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  name="expense_date"
                  label="Expense Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={formData.expense_date}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  name="amount"
                  label="Amount"
                  fullWidth
                  value={formData.amount}
                  onChange={handleChange}
                  // InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name="notes"
                  label="Notes"
                  fullWidth
                  multiline
                  minRows={2}
                  value={formData.notes}
                  onChange={handleChange}
                />
              </Grid>

              {/* ✅ Line Items Table */}
           <Grid item xs={12}>
  <div className="mt-6">
    {/* Header with Add Button */}
    <div className="flex justify-between items-center mb-4">
      <button
        type="button"
        className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded shadow transition"
        onClick={addLineItem}
      >
        + Add Item
      </button>
    </div>

    {/* Table Container */}
    <div className="border border-gray-300 rounded-lg overflow-hidden shadow-sm">
      {/* Table Header */}
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm text-left bg-gray-50">
          <thead className="bg-gray-100 sticky top-0 z-10">
            <tr>
              <th className="border px-4 py-3 font-semibold text-gray-700">Task</th>
              <th className="border px-4 py-3 font-semibold text-gray-700">Inventory</th>
              <th className="border px-4 py-3 font-semibold text-gray-700">Type</th>
              <th className="border px-4 py-3 font-semibold text-gray-700">Unit Price ($)</th>
              <th className="border px-4 py-3 font-semibold text-gray-700">Quantity</th>
              <th className="border px-4 py-3 font-semibold text-center text-gray-700">
                Actions
              </th>
            </tr>
          </thead>


      {/* Scrollable Body */}
  
          <tbody  className="min-w-full text-sm text-left bg-white">
            {lineItems?.map((item, index) => (
              <tr key={index} className="hover:bg-gray-50 transition">
                {/* Task Select */}
                <td className="border px-3 py-2">
                  <select
                    className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={item.task_id}
                    required
                    onChange={(e) =>
                      handleLineItemChange(index, "task_id", e.target.value)
                    }
                  >
                    <option value="">Select Task</option>
                    {taskList.map((t) => (
                      <option key={t.id} value={t.id}>
                        {t.task_code} - {t.task_name}
                      </option>
                    ))}
                  </select>
                </td>

                {/* Inventory Select */}
                <td className="border px-3 py-2">
                  <select
                    className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={item.inventory_id}
                    required
                    onChange={(e) =>
                      handleLineItemChange(index, "inventory_id", e.target.value)
                    }
                  >
                    <option value="">Select Inventory</option>
                    {invetoryArray.map((inv) => (
                      <option key={inv.id} value={inv.id}>
                        {inv.inventory_name}
                      </option>
                    ))}
                  </select>
                </td>

                {/* Expense Type */}
                <td className="border px-3 py-2">
                  <select
                    className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={item.expense_type}
                    required
                    onChange={(e) =>
                      handleLineItemChange(index, "expense_type", e.target.value)
                    }
                  >
                    <option value="">Select Type</option>
                    {expenseTypes.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </td>

                {/* Unit Price */}
                <td className="border px-3 py-2">
                  <input
                    type="number"
                    className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={item.unit_price}
                    onChange={(e) =>
                      handleLineItemChange(index, "unit_price", e.target.value)
                    }
                  />
                </td>

                {/* Quantity */}
                <td className="border px-3 py-2">
                  <input
                    type="number"
                    className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={item.quantity}
                    onChange={(e) =>
                      handleLineItemChange(index, "quantity", e.target.value)
                    }
                  />
                </td>

                {/* Remove Button */}
                <td className="border px-3 py-2 text-center">
                  <IconButton
                    onClick={() => removeLineItem(index)}
                    className="text-red-600 hover:text-red-800 transition"
                    title="Remove item"
                  >
                    <Delete />
                  </IconButton>
                </td>
              </tr>
            ))}
          </tbody>
     
        </table>
      </div>
    </div>
  </div>
</Grid>

            </Grid>
          </DialogContent>
          <DialogActions>
            <Button type="button" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="contained" type="submit">
              {editMode ? "Update" : "Save"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

  const getSiteTypeColor = (siteType) => {
    const colors = {
      Residential: "primary",
      Commercial: "secondary",
      Industrial: "warning",
      Infrastructure: "info",
    };
    return colors[siteType] || "default";
  };

  const getProgressColor = (progress) => {
    if (progress >= 80) return "success";
    if (progress >= 60) return "info";
    if (progress >= 40) return "warning";
    return "error";
  };  

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
